import { h } from 'preact'

const Tooltip = ({ trigger, qaClasses, customClasses, tooltipMessage, withArrow } : {
  trigger: string | JSX.Element,
  qaClasses?: string,
  customClasses?: string,
  tooltipMessage: string | JSX.Element,
  withArrow?: boolean
}) => (
  <span className='tooltip-container'>
    <span className={`tooltip-trigger ${qaClasses || ''}`}>
      {trigger}
    </span>
    <span className={`tooltip-message ${customClasses || ''}`}>
      { withArrow && <i class='arrow' /> }
      {tooltipMessage}
    </span>
  </span>
)

export default Tooltip
